import { useEffect, useState } from 'react'
import { LongButton } from '../../../components/buttons/longButton/LongButton'
import { translations } from '../../../configs/translations'
import { Language } from '../../../context/LanguageContext'
import { ChatDto, ChatResponse } from '../../../models/ChatDto'
import UserService from '../../../services/UserService'
import { Chat } from './chat/Chat'
import './Footer.css'

export const Footer = () => {
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const [isChatOpen, setIsChatOpen] = useState(false)

    const [chats, setChats] = useState<ChatResponse | null>(null)
    const [activeChat, setActiveChat] = useState<ChatDto | null>(null)

    const fetchChats = async () => {
        try {
            const response = await UserService.getChats()
            setChats(response)
        } catch (error) {
            console.error('Error in fetchChats:', error)
        }
    }

    useEffect(() => {
        fetchChats()

        const token = localStorage.getItem('accessToken')
        const eventSource = UserService.getChatsSSE(token as string || '')

        eventSource.addEventListener("INIT", (e) => {
            console.log("SSE connected:", e.data)
        })

        eventSource.addEventListener("UPDATE_CHATS", (e) => {
            try {
                const response: ChatResponse = JSON.parse(e.data)

                const isEquals = chats?.chats?.every(chat => response.chats?.some(chat2 =>
                    chat2.id === chat.id
                    && chat2.name === chat.name
                    && chat2.hasUnreadMessages === chat.hasUnreadMessages
                ))

                if (!isEquals) {
                    setChats(response)
                }
            } catch (err) {
                console.error(err)
            }
        })

        eventSource.onerror = (err) => {
            eventSource.close()
        }

        return () => {
            eventSource.close()
        }
    }, [])

    return (
        <div className="footer">
            {chats && (
                <div>
                    {chats?.chats?.map((chat, index) => (
                        <LongButton
                            key={chat.id}
                            text={chat.name}
                            onClick={() => {
                                chat.index = index
                                setActiveChat(chat)
                                setIsChatOpen(!isChatOpen)
                            }}
                            isShining={chat.hasUnreadMessages && !isChatOpen}
                        />
                    ))}
                </div>
            )}
            {activeChat && (
                <Chat
                    key={activeChat.id}
                    id={activeChat.id}
                    name={activeChat.name}
                    right={110 + (activeChat.index! + 1) * 100}
                    isOpen={isChatOpen}
                    setIsChatOpen={setIsChatOpen}
                />
            )}
        </div>
    )
}